import normalizeData from '../../lib/normalizeData'

export default (data) => ({
  data: normalizeData(data),
})
